export default __webpack_public_path__ + "static/media/questor-scoring-demo.ff13cc9d.mp4";